import { render } from "./KriDetailsModal.vue?vue&type=template&id=8c60f92a&scoped=true"
import script from "./KriDetailsModal.js?vue&type=script&lang=js"
export * from "./KriDetailsModal.js?vue&type=script&lang=js"

import "./KriDetailsModal.vue?vue&type=style&index=0&id=8c60f92a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c60f92a"]])

export default __exports__